import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import Helmet from 'react-helmet';
import OrderStore from '../../stores/OrderStore';
import OrderReceipt from '../../components/OrderReceipt';
import Breadcrumbs from '../../components/Breadcrumbs';
import styles from '../BaseContainer/index.sass';

class OrderContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(order, store) {
    let title = `Order receipt #${order.order_number} – ${store.name}`;
    return {
      title: title,
      meta: []
    };
  }

  render() {
    let { order, store } = this.props;
    let orderReceiptProps = { order, store };
    let breadcrumbsProps = {
      links: [{routeName: 'storeLandingPage'}, {text: 'Order history', routeName: 'orderHistory'}]
    };
    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(order, store)} />
        <Breadcrumbs {...breadcrumbsProps} />
        <OrderReceipt {...orderReceiptProps} />
      </section>
    );
  }
}

OrderContainer = connectToStores(OrderContainer, [OrderStore], (context, props) => {
  return {
    order: context.getStore(OrderStore).getEntityById(props.currentRoute.params.id)
  };
});

export default OrderContainer;



// WEBPACK FOOTER //
// banquet/containers/OrderContainer/index.js